import { Mountain, SoccerBall } from '../../components/ui/icons';
import { AppShell, Content } from '../../components/ui/AppShell';
import { BackBar } from './BackBar';
import { FixtureShell } from './FixtureShell';

export function MatchNotFound({
  isCycling,
  onBack
}: {
  isCycling: boolean;
  onBack: () => void;
}) {
  if (isCycling) {
    return (
      <AppShell refreshable={false}>
        <Content>
          <BackBar onBack={onBack} eyebrow="Duel detail" tone="light" />
          <div className="mt-4 flex flex-col items-center rounded-[20px] border border-dashed border-black/12 bg-[#FAFAFB] px-6 py-14 text-center">
            <div className="grid h-14 w-14 place-items-center rounded-2xl bg-[#EFEFF3]">
              <Mountain width={26} height={26} strokeWidth={1.8} className="text-ink3" />
            </div>
            <div className="mt-4 text-[18px] font-extrabold tracking-tight text-ink">Duel not found</div>
            <p className="mt-2 max-w-[300px] text-[14px] font-medium leading-[1.45] text-ink2">
              This duel isn’t part of the current stage.
            </p>
          </div>
        </Content>
      </AppShell>
    );
  }

  return (
    <FixtureShell>
      <BackBar onBack={onBack} eyebrow="Match detail" />
      <div className="mt-4 flex flex-col items-center rounded-[28px] border border-dashed border-white/15 bg-white/[0.04] px-6 py-14 text-center">
        <div className="grid h-14 w-14 place-items-center rounded-2xl bg-white/[0.07]">
          <SoccerBall width={26} height={26} strokeWidth={1.8} className="text-white/55" />
        </div>
        <div className="mt-4 text-[18px] font-extrabold tracking-tight text-white">Match not found</div>
        <p className="mt-2 max-w-[300px] text-[14px] font-medium leading-[1.45] text-white/55">
          This fixture isn’t part of the current round.
        </p>
      </div>
    </FixtureShell>
  );
}
